import { Link } from '@iwoca/orion';
import { Checkbox } from 'react-bootstrap';
import { connect } from 'react-redux';

import { getCountryCode } from '@lendingAPI/lendingAPISelector';
import { getSplitTestValue } from '@src/utils/selectors';

import styles from './PrivacyPolicyAgreement.module.css';
import FormField from '../FormField';

const mapStateToProps = (state) => ({
    isAutoAgreedPrivacyPolicy:
        getSplitTestValue(state, 'privacy_policy_default_agreement_test') &&
        getCountryCode(state) === 'uk'
});

const PrivacyPolicyAgreement = ({
    field,
    onTick,
    isAutoAgreedPrivacyPolicy
}) => {
    if (isAutoAgreedPrivacyPolicy) {
        return (
            <div
                className={(styles.privacyPolicyContainer, styles.noCheckBox)}
                data-testid="privacy-policy-section">
                <p>
                    <strong>We use your personal information</strong> and that
                    of your{' '}
                    <strong>
                        company directors, beneficial owners or guarantors
                    </strong>{' '}
                    in the following ways. (Please make them aware of this
                    before you provide their information to us)
                </p>
                <ul>
                    <li>
                        <strong>
                            We’ll share it with credit reference agencies to run
                            soft credit and identity checks
                        </strong>{' '}
                        - this won’t affect your personal credit score
                    </li>
                    <li>
                        <strong>
                            We may ask you to provide a personal guarantee.
                        </strong>{' '}
                        We’ll only conduct credit checks on you and any other
                        guarantors.
                    </li>
                    <li>
                        <strong>
                            We’ll share it with fraud prevention agencies
                        </strong>{' '}
                        - if we do spot fraud, you could be refused services,
                        finance, or employment.
                    </li>
                    <li>
                        <strong>We might record your calls with us.</strong>
                    </li>
                </ul>
                <p>
                    <strong>
                        By clicking 'submit details' you agree to all of the
                        above.
                    </strong>{' '}
                    If you’d like to find out more, check our{' '}
                    <Link
                        size="small"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.iwoca.co.uk/privacy_policy/">
                        privacy policy
                    </Link>
                    .
                </p>
                <p>iwoca Ltd is the data controller.</p>
            </div>
        );
    }

    return (
        <FormField wrapperGrid={{ sm: 12 }} field={field}>
            <Checkbox
                checked={!!field.value}
                onChange={onTick}
                data-testid="privacy-policy-checkbox"
                className="legal-check legal-personal">
                <div data-testid="privacy-policy-section">
                    <p>
                        <b>Here’s how we use your personal information</b> and
                        that of your company directors, beneficial owners or
                        guarantors. (Please make them aware of this before you
                        provide their information to us)
                    </p>
                    <ul>
                        <li>
                            <strong>
                                We’ll share it with credit reference agencies to
                                run soft credit and identity checks
                            </strong>{' '}
                            - this won’t affect your personal credit score
                        </li>
                        <li>
                            <strong>
                                We may ask you to provide a personal guarantee.
                            </strong>{' '}
                            We’ll only conduct credit checks on you and any
                            other guarantors.
                        </li>
                        <li>
                            <strong>
                                We’ll share it with fraud prevention agencies
                            </strong>{' '}
                            - if we do spot fraud, you could be refused
                            services, finance, or employment.
                        </li>
                        <li>
                            <strong>We might record your calls with us.</strong>
                        </li>
                    </ul>
                    <p>
                        If you’d like to find out more, check our{' '}
                        <Link
                            size="small"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.iwoca.co.uk/privacy_policy/">
                            privacy policy
                        </Link>
                        .
                    </p>
                    <p>iwoca Ltd is the data controller.</p>
                </div>
            </Checkbox>
        </FormField>
    );
};

export default connect(mapStateToProps)(PrivacyPolicyAgreement);
